import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDeliveryMapGeometry } from './deliveryMapApi';
import { normalizeDeliveryMapBounds } from './deliveryMapBounds';
import { DeliveryMapBounds, DeliveryMapParams } from './deliveryMapTypes';

export function useDeliveryMapGeometry() {
  const [params, setParams] = useState<DeliveryMapParams | null>(null);
  const onBoundsChange = useCallback((viewport: DeliveryMapBounds): void => {
    const bounds = normalizeDeliveryMapBounds(viewport);
    if (bounds === null) return;
    setParams((current) => {
      const unchanged = current !== null && current.west === bounds.west && current.south === bounds.south && current.east === bounds.east && current.north === bounds.north;
      return unchanged ? current : { ...bounds, page: 1 };
    });
  }, []);
  const query = useQuery({
    queryKey: ['admin', 'delivery-map', params],
    queryFn: ({ signal }) => {
      if (params === null) throw new Error('Область карты ещё не выбрана.');
      return getDeliveryMapGeometry(params, signal);
    },
    enabled: params !== null,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
  const changePage = (page: number): void => {
    if (query.isFetching) return;
    setParams((current) => current === null ? current : { ...current, page });
  };
  const refresh = (): void => { if (params !== null && !query.isFetching) void query.refetch(); };
  return { query, onBoundsChange, changePage, refresh, hasViewport: params !== null };
}
